<template>
  <div>
    <div>
      <el-row>
        <el-col :span="12">
          <div style="margin-right: 20px;height:250px;" class="whiteBox">
            <h4 style="display:flex;  justify-content: space-between;">
              <span>基本信息</span>
              <span
                class="click_link"
                style="font-weight:400"
                @click="isUpdate = true"
                >更新</span
              >
            </h4>
            <div class="pure-g form-section">
              <div class="pure-u-1-5">经销商名称</div>
              <div class="pure-u-4-5" style="font-weight:500;">
                {{ dealer.company }}
              </div>
            </div>
            <div class="pure-g form-section">
              <div class="pure-u-1-5">成员数量</div>
              <div class="pure-u-4-5" style="font-weight:500;">
                {{ dealerProfile.memberCount }}
              </div>
            </div>
            <div class="pure-g form-section">
              <div class="pure-u-1-5">文件数量</div>
              <div class="pure-u-4-5" style="font-weight:500;">
                {{ dealerProfile.fileCount }}
              </div>
            </div>
            <div class="pure-g form-section-last">
              <div class="pure-u-1-5">地址</div>
              <div class="pure-u-4-5" style="font-weight:500;">
                {{ dealerProfile.address }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="margin-right: 20px;height:250px;" class="whiteBox">
            <h4>
              <span>公告</span>
              <el-button
                size="medium"
                type="text"
                style="float:right;margin-top:-7px;"
                class="filter-item"
                @click="showTopicDialog"
                >更新</el-button
              >
            </h4>
            <div class="pure-g form-section-last">
              <div
                class="pure-u-5-5"
                style="width: 100%;overflow-wrap: break-word;;height:240px;overflow-y:auto;font-weight:500;"
              >
                {{
                  dealerProfile.topic == ""
                    ? "还未留下公告..."
                    : dealerProfile.topic
                }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px;">
        <el-col :span="12">
          <div
            :class="{ oldH: swichData.role == 2 || swichData.role == 9 }"
            style="margin-right: 20px;"
            class="whiteBox"
          >
            <h4>
              <span>策略设置</span>
            </h4>
            <div class="pure-g form-section">
              <div class="pure-u-1-5 col-label" style="line-height:24px;">
                限制客户经理登录
              </div>
              <div class="pure-u-4-5" style="font-weight:500;">
                <el-switch
                  v-model="dealerProfile.policy.forbitSalesLoginPc"
                  @change="doSwitchSalesLoginPc"
                ></el-switch>
              </div>
            </div>
            <div class="pure-g form-section-last">
              <div class="pure-u-1-5">线上策略处理</div>
              <div class="pure-u-3-5" style="font-weight:500;">
                {{ dealerProfile.policy.online | onlineMethodDisplay }}
              </div>
              <div class="pure-u-1-5" style="text-align: right;">
                <span class="click_link" @click="showOnlineSettingDialog"
                  >设置</span
                >
              </div>
            </div>
            <div class="pure-g form-section-last">
              <div class="pure-u-4-5">微信线索清洗人员设置</div>
              
              <div class="pure-u-1-5" style="text-align: right;">
                <span class="click_link" @click="showWXClearPeople"
                  >新增</span
                >
              </div>
            </div>
            <el-table :data="tableRecords" stripe v-loading="listLoading">
              <el-table-column align="left" label="线索渠道" width="120" prop="source">
                <template slot-scope="scope">{{ transformLabel(scope.row.source, wechatClueSources)  }}</template>
              </el-table-column>
              <el-table-column align="left" label="清洗人员" prop="people">
                <template slot-scope="scope">{{ scope.row.members && scope.row.members.length ? scope.row.members.map(item=>item.name).join('、') : '' }}</template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="90" prop="operation">
                <template slot-scope="scope">
                  <span
                    class="click_link gg"
                    @click="deleteWXClearPeople(scope.row)"
                  >删除</span>
                  <span
                    class="click_link"
                    @click="showWXClearPeople(scope.row)"
                  >设置</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            v-if="
              swichData.role == 2 ||
                swichData.role == 9 ||
                swichData.role == 3 ||
                swichData.role == 11
            "
            style="margin-right: 20px;height:20px;margin-top:20px"
            class="whiteBox"
          >
            <h4
              style="display:flex;  justify-content: space-between;border:none"
            >
              <span>切换门店</span>
              <span
                class="click_link"
                style="font-weight:400"
                @click="isSwitch = true"
                >切换</span
              >
            </h4>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="margin-right: 20px;height:250px;" class="whiteBox">
            <h4 style="display:flex;  justify-content: space-between;">
              <span>客户来源自定义</span>
              <span
                class="click_link"
                style="font-weight:400"
                @click="isCustomization = true"
                >添加</span
              >
            </h4>
            <div class="boxss">
              <div
                v-for="(item, index) in customizationList"
                :key="index"
                class="box"
              >
                <span>{{ item.name }}</span>
                <div>
                  <span class="click_link gg" @click="edit(item)">编辑</span>
                  <span
                    class="click_link gg"
                    @click="deleteCustomization(item.id)"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="更新公告"
      :visible.sync="topicDialog"
      width="350px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="topicForm"
        :model="topicForm"
        :rules="topicFormRules"
      >
        <el-form-item label="" prop="topic">
          <el-input
            type="textarea"
            v-model="topicForm.topic"
            :rows="5"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doSaveTopic" type="text">更新</el-button>
        <el-button @click="topicDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="线上线索分配策略"
      :visible.sync="onlineSettingDialog"
      width="400px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div v-if="groupId === 0">
        <el-radio v-model="onlineSetting" :label="1"
          >BDC/新媒体线索挖掘专员清洗，主管分配</el-radio
        >
        <br />
        <br />
        <el-radio v-model="onlineSetting" :label="2">BDC/新媒体线索挖掘专员清洗，BDC分配</el-radio>
        <br />
        <br />
        <el-radio v-model="onlineSetting" :label="3"
          >无BDC清洗，自动分配</el-radio
        >
      </div>
      <div v-else>
        <h3>集团DCC清洗</h3>
        <br />
        <h4>主管分配</h4>
        <p>
          集团门店线索由集团DCC人员进行统一清洗，清洗后，线索分配至店端管理人员，由店端管理层手动进行
        </p>
        <br />
        <h4>自动分配</h4>
        <p>
          集团门店线索由集团DCC人员进行统一清洗，清洗后，线索轮流分配至店端有线上线索权限的客户经理名下
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="doSaveOnlineSetting"
          type="text"
          v-show="groupId === 0"
          >更新</el-button
        >
        <el-button @click="onlineSettingDialog = false" type="text"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="添加自定义来源"
      :visible.sync="isCustomization"
      width="350px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="customization"
        placeholder="请输入来源名"
        size="small"
        style="width: 200px;"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doSaveCustomization" type="text">确定</el-button>
        <el-button @click="isCustomization = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑自定义来源"
      :visible.sync="isEditCustomization"
      width="350px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="editCustomization"
        placeholder="请输入来源名"
        size="small"
        style="width: 200px;"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doEditCustomization" type="text">确定</el-button>
        <el-button @click="isEditCustomization = false" type="text"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="更新地址"
      :visible.sync="isUpdate"
      width="400px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="userForm"
        :model="userForm"
        :rules="userFormRules"
      >
        <el-form-item label="" prop="address">
          <el-input
            type="textarea"
            v-model="userForm.address"
            autosize
            :rows="3"
            size="small"
            placeholder="请输入地址"
            style="width: 350px;"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doUpdate" type="text">确定</el-button>
        <el-button @click="isUpdate = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="切换门店"
      :visible.sync="isSwitch"
      width="400px"
      class="swichlog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="checkId">
        <div v-for="(row, index) in dealersList" :key="index">
          <div style="font-size: 13px; font-weight: bold; margin-bottom: 10px;" :style="{marginTop: index == 0 ? '0' : '10px'}">
            <span style="margin-right: 20px;">手机号：{{ row.mobile }}</span>
            <span>工号：{{ row.empNo }}</span>
          </div>
          <el-radio :label="`${item.dealerId}-${row.userId}`" v-for="(item, index) in row.dealerInfo" :key="index"
            :disabled="`${dealer.dealerId}-${dealer.userId}` == `${item.dealerId}-${row.userId}`">{{ item.name }}</el-radio>
        </div>
      </el-radio-group>

      <span slot="footer" class="dialog-footer">
        <el-button @click="switchDealer" type="text">确定</el-button>
        <el-button @click="isSwitch = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="WXClearPeopleDialog"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="wxClearForm"
        :model="wxClearForm"
        :rules="wxClearFormRules"
        label-width="80px"
      >
        <el-form-item label="线索渠道" prop="source">
          <el-select v-model="wxClearForm.source" placeholder="请选择线索渠道" style="width: 100%">
            <el-option v-for="item in filterWechatClueSources" :key="item.dataName" :label="item.dataDisplay" :value="item.dataName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="清洗人员" prop="people">
          <el-select v-model="wxClearForm.people" placeholder="请选择清洗人员" multiple clearable filterable style="width: 100%">
            <el-option v-for="(item, index) in assignMembers" :key="`${item.memberId}-${index}`" :label="item.memberName" :value="item.memberId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSaveWXClearPeople" type="text">保存</el-button>
        <el-button @click="WXClearPeopleDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Cookies from "js-cookie";
import { remarkValidator } from '@/assets/js/util'
import { getExplore } from '@/assets/js/util'
import { deviceTypeMap } from "@/assets/js/commonMap.js";
const explore = getExplore()

export default {
  data() {
    return {
      isSwitch: false,
      swichData: this.$common.getLoginInfo(),
      checkId: null,
      isCustomization: false,
      isEditCustomization: false,
      customization: "",
      editCustomization: "",
      sourceId: "",
      customizationList: [],
      dealer: this.$common.getDealer(),
      dealerProfile: {
        policy: {
          online: 3,
        },
        signSetting: {
          inTime: "08:30",
          offTime: "18:00",
          whites: [],
          isAlert: false,
        },
      },

      topicDialog: false,

      onlineSettingDialog: false,
      WXClearPeopleDialog: false,
      wxClearForm: {
        source: '',
        people: []
      },
      wxClearFormRules: { 
        source: [
          { required: true, message: "请选择来源", trigger: "blur" },
        ],
        people: [
          { required: true, message: "请选择人员", trigger: "blur" },
        ]
      },
      onlineSetting: 3,

      whiteDialog: false,
      controlUsers: [],
      isUpdate: false,
      groupId: 0,
      topicForm: {
        topic: ""
      },
      topicFormRules: {
        topic:[
          {
            required: true,
            validator: (...args) => {
              remarkValidator("公告内容", ...args)
            },
            trigger: "blur"
          }
        ],
      },
      userForm: {
        address: ""
      },
      userFormRules: {
        address:[
          {
            required: true,
            validator: (...args) => {
              remarkValidator("地址", ...args)
            },
            trigger: "blur"
          }
        ],
      },
      form: {
        deviceType: '',
        deviceVersion: '', // 操作系统版本 window11
        device: `${explore.name} ${explore.fullVersion}`, // 浏览器类型
      },
      tableRecords: [], // 微信线索清洗配置人员
      listLoading: false,
      wechatClueSources: [], // 微信线索来源
      assignMembers: [],
      currSource: '',
      dccVirtualDealer: '', // DCC虚拟门店id
    };
  },
  computed: {
    ...mapGetters('common', ['osInfo']),
    filterWechatClueSources() {
      return this.wechatClueSources.filter(item => this.currSource === item.dataName || this.tableRecords.every(row => row.source !== item.dataName ) );
    },
     // 过滤DCC虚拟门店 虚拟门店不允许切换
    dealersList() {
      const value = this.swichData.allDealers.map(item => { 
        item.dealerInfo = item.dealerInfo.filter(otem => otem.dealerId !== this.dccVirtualDealer)
        return  item
      });
      return value;
    }
  },
  filters: {
    onlineMethodDisplay(id) {
      const statusMap = {
        1: "BDC/新媒体线索挖掘专员清洗，主管分配",
        2: "BDC/新媒体线索挖掘专员清洗，BDC分配",
        3: "无BDC清洗，自动分配",
      };
      return statusMap[id];
    },
  },
  async created() {
    this.retrieveDealerProfile();
    this.getcustomizationList();
    this.retrieveAssignMembers();
    this.getWXClearPeoplelist()
    await this.getModernOSInfo()
    const { name, versionName } = this.osInfo
    this.form.deviceVersion = versionName
    this.form.deviceType = name
    const { dealerId, userId } = this.$common.getDealer();
    this.checkId = `${dealerId}-${userId}`
    const baseInfo = this.$common.getBaseInfo();
    this.wechatClueSources = baseInfo.wechatClueSources || [];
    this.getDccVirtualDealer();
    // this.checkStatus();
  },
  methods: {
    ...mapActions('common', ['getModernOSInfo']),
    getDccVirtualDealer() {
      this.$httpAuth
        .post("/v2/appCustomerService/getDccVirtualDealer", {})
        .then((response) => {
          this.dccVirtualDealer = response.data.dealerId;
        })
        .catch(() => { });
    },
    doUpdate() {
      this.$refs.userForm.validate(async valid => {
        if (valid) {
          this.$httpAuth
            .post("/v2/appDealerManagerService/updateAddress", {
              dealerId: this.dealer.dealerId,
              address: this.userForm.address,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "更新成功",
                  type: "success",
                });
                this.retrieveDealerProfile();
                this.isUpdate = false;
              }
            });   
        }
      })
    },
    switchDealer() {
      var that = this;
      const [ dealerId, userId ] = this.checkId.split('-').map(Number);
      const refreshToken = Cookies.get("Dealer-User-RefreshToken");
      this.$httpAuth
        .post("/v2/appUserService/switchDealer", {
          dealerId,
          userId,
          refreshToken,
          ...this.getParams()
        })
        .then((res) => {
          this.swichData = { ...res.data };
          Cookies.set("Dealer-User-Token", res.data.token);
          Cookies.set("Dealer-User-RefreshToken", res.data.refreshToken);
          that.$common.setDealer(res.data.profile);
          that.$common.setAdmin(res.data.isAdmin);
          that.$common.setLoginInfo(res.data);
          that.dealer = that.$common.getDealer();
          that.$httpAuth
            .post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN })
            .then(function(res) {
              that.isSwitch = false;
              that.$common.setBaseInfo(res.data);
              that.$router.go(0);
              //   that.retrieveDealerProfile()
              //   that.getcustomizationList()
            })
            .catch(() => {
              that.isSwitch = false;
            });
        });
    },
    getParams() {
      const { device, deviceVersion, deviceType } = this.form
      let value = {
        device,
        deviceType: deviceTypeMap.get(deviceType) ?? 0, // deviceType：0 pc windows, 1 ANDROID 2: ios 3.小程序 4. 鸿蒙 5 pc mac
        deviceVersion,
      }
      return value
    },
    edit(item) {
      this.editCustomization = item.name;
      this.isEditCustomization = true;
      this.sourceId = item.id;
    },
    deleteCustomization(id) {
      this.$confirm("确定删除该自定义来源?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var that = this;
          this.$httpAuth
            .post("/v2/appDealerManagerService/deleteSource", {
              dealerId: that.dealer.dealerId,
              sourceId: id,
            })
            .then((res) => {
              if (res.data.success) {
                that.$message({
                  message: "删除成功",
                  type: "success",
                });
                that.getcustomizationList();
              }
            });
        })
        .catch(() => {});
    },
    doSaveCustomization() {
      var that = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/addSource", {
          dealerId: this.dealer.dealerId,
          name: this.customization,
        })
        .then((res) => {
          if (res.data.success) {
            that.$message({
              message: "添加成功",
              type: "success",
            });
            that.getcustomizationList();
            that.customization = "";
            that.isCustomization = false;
          }
        });
    },
    doEditCustomization() {
      var that = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/updateSource", {
          dealerId: this.dealer.dealerId,
          name: this.editCustomization,
          sourceId: this.sourceId,
        })
        .then((res) => {
          if (res.data.success) {
            that.$message({
              message: "编辑成功",
              type: "success",
            });
            that.getcustomizationList();
            that.editCustomization = "";
            that.isEditCustomization = false;
          }
        });
    },
    getcustomizationList() {
      this.$httpAuth
        .post("/v2/appDealerManagerService/sourceList", {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.customizationList = res.data.data;
        });
    },
    retrieveDealerProfile() {
      this.$httpAuth
        .post("/v1/dealerRpc/profile", {
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.dealerProfile = response.data;
          this.userForm.address = this.dealerProfile.address;
          this.dealerProfile.signSetting.whites = response.data.signSetting.whites.split(
            ","
          );
        })
        .catch(() => {});
    },
    showTopicDialog() {
      this.topicForm.topic = this.dealerProfile.topic;
      this.topicDialog = true;
    },
    doSaveTopic() {
      this.$refs.topicForm.validate(async valid => {
        if (valid) {
          this.$httpAuth
            .post("/v1/dealerRpc/updateTopic", {
              dealerId: this.dealer.dealerId,
              content: this.topicForm.topic,
            })
            .then(() => {
              this.retrieveDealerProfile();
              this.topicDialog = false;
            })
            .catch(() => {});     
          }
      })
    },
    retrieveAssignMembers() {
      this.$httpAuth
        .post("/v2/appDealerManagerService/allMembersList", {
          dealerId: this.dealer.dealerId
        })
        .then((response)=> {
          this.assignMembers = response.data.data;
        });
    },
    getWXClearPeoplelist() {
      this.listLoading = true;
      this.$httpAuth
        .post("/v1/dealerRpc/wechatClueClearMembers", {
          "dealerId": this.dealer.dealerId,
        })
        .then((response)=> {
          this.tableRecords = response.data.data;
        }).finally(() => { 
          this.listLoading = false; 
        })
    },
    transformLabel(val, list) {
      const row = list.find(item => item.dataName === val);
      return row ? row.dataDisplay : '';
    },
    showOnlineSettingDialog() {
      this.onlineSetting = this.dealerProfile.policy.online;
      this.onlineSettingDialog = true;
    },
    showWXClearPeople(row) {
      this.currSource = '';
      if(row) {
        const { source = '', members = [] } = row
        this.currSource = source;
        this.wxClearForm.source = source;
        this.wxClearForm.people = members ? members.map(item => item.memberId) : '';
      }
      this.WXClearPeopleDialog = true;
    },
    deleteWXClearPeople(row) {
      this.$confirm('确认删除？删除后该渠道微信线索将轮询平均分配给对应的清洗人员', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpAuth
            .post("/v1/dealerRpc/wechatClueClearMemberUpdate", {
              "dealerId": this.dealer.dealerId,
              source: row.source,
              memberIds: ''
            })
            .then(()=> {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getWXClearPeoplelist();
            })
        })
    },
    handleSaveWXClearPeople() {
      this.$refs.wxClearForm.validate(async valid => {
        if (valid) {
          const { source = '', people = [] } = this.wxClearForm
          console.log(this.wxClearForm, 'this.wxClearFormthis.wxClearFormthis.wxClearForm')
          this.$httpAuth
            .post("/v1/dealerRpc/wechatClueClearMemberUpdate", {
              dealerId: this.dealer.dealerId,
              source,
              memberIds: people.join(',')
            })
            .then(() => {
              this.$refs.wxClearForm.clearValidate();
              this.WXClearPeopleDialog = false;
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.getWXClearPeoplelist();
            })
            .catch(() => {});     
          }
      })
    },
    doSaveOnlineSetting() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/updatePolicy", {
          dealerId: this.dealer.dealerId,
          fail: 1,
          delay: 1,
          delivery: 1,
          online: this.onlineSetting,
        })
        .then(function() {
          parent.onlineSettingDialog = false;
          parent.retrieveDealerProfile();
        })
        .catch(() => {});
    },
    doSwitchSalesLoginPc() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/switchSalesLoginPc", {
          dealerId: this.dealer.dealerId,
          forbit: this.dealerProfile.policy.forbitSalesLoginPc,
        })
        .then(function() {
          parent.retrieveDealerProfile();
        })
        .catch(() => {});
    },
    checkStatus() {
      this.$httpAuth
        .post("/v2/v2AppDealerDccService/checkStatus", {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.groupId = res.data.groupId;
        });
    },
  },
};
</script>
<style>
.boxss {
  width: 100%;
  height: 250px;
  overflow-y: auto;
}

.box {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}

.gg {
  font-weight: 400;
  margin-right: 10px;
}

/* .oldH {
  height: 200px !important;
} */

.swichlog .el-dialog__body .el-radio-group {
  display: flex;
  flex-direction: column;
}

.el-radio + .el-radio {
  margin-left: 0;
  margin-top: 5px;
}
</style>
